import * as Haptics from 'expo-haptics';
import { Platform, Vibration } from 'react-native';

function canFeedback() {
  return Platform.OS === 'ios' || Platform.OS === 'android';
}

async function runFeedback(
  effect: () => Promise<void>,
  fallbackDuration: number,
) {
  if (!canFeedback()) {
    return;
  }

  try {
    await effect();
  } catch {
    // Fall back to built-in vibration if the native haptics module is missing.
    try {
      Vibration.vibrate(fallbackDuration);
    } catch {
      // Keep account switching responsive even if device feedback is unavailable.
    }
  }
}

export async function triggerSelectionHaptic() {
  await runFeedback(() => Haptics.selectionAsync(), 10);
}

export async function triggerConfirmHaptic() {
  await runFeedback(() => Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light), 20);
}
